// HintPanel.jsx — practice-only "Hint" assistant overlay.
// Reuses the same analysis engine as Auto-Arrange to suggest groupings, the best
// discard, and whether the top discard card is worth picking up.
import React, { useState } from 'react';
import { analyzeHand, evaluatePickup } from '../../../utils/suggestionEngine';

const suit = (s) => ({ hearts: '♥', diamonds: '♦', clubs: '♣', spades: '♠' }[s] || '');

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 14 }}>
    <h3 style={{ margin: '0 0 6px', fontSize: 14, color: '#f59e0b' }}>{title}</h3>
    {children}
  </div>
);

const HintPanel = ({ hand = [], discardTop = null, wildJoker = null }) => {
  const [open, setOpen] = useState(false);

  const analysis = analyzeHand(hand, wildJoker);
  const pickup = evaluatePickup(hand, discardTop, wildJoker);

  return (
    <>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          position: 'fixed',
          top: 70,
          right: 16,
          zIndex: 1000,
          background: '#f59e0b',
          color: '#1a1a2e',
          border: 'none',
          borderRadius: 24,
          padding: '10px 18px',
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
          fontSize: 14,
        }}
      >
        💡 Hint
      </button>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.55)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#14142b',
              color: '#eaeaf5',
              borderRadius: 14,
              padding: 22,
              maxWidth: 460,
              width: '92%',
              maxHeight: '80vh',
              overflow: 'auto',
              border: '1px solid #2c2c4a',
              boxShadow: '0 10px 40px rgba(0,0,0,0.6)',
            }}
          >
            <h2 style={{ margin: '0 0 4px', fontSize: 20 }}>💡 Hint</h2>
            <p style={{ margin: '0 0 16px', color: '#9aa0b5', fontSize: 13 }}>
              Suggestions based on your current hand.
            </p>

            <Section title="Suggested groups">
              {analysis.combinations.length ? (
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                  {analysis.combinations.map((c, i) => (
                    <li key={i} style={{ marginBottom: 6 }}>{c}</li>
                  ))}
                </ul>
              ) : (
                <p style={{ color: '#9aa0b5' }}>No complete sets or sequences yet.</p>
              )}
            </Section>

            <Section title="Cards to look for">
              {analysis.hints.length ? (
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                  {analysis.hints.map((h, i) => (
                    <li key={i} style={{ marginBottom: 6 }}>{h}</li>
                  ))}
                </ul>
              ) : (
                <p style={{ color: '#9aa0b5' }}>No specific draws to target right now.</p>
              )}
            </Section>

            <Section title="Discard pile">
              <p style={{ margin: 0, color: pickup.useful ? '#4ade80' : '#f87171' }}>
                {pickup.description}
              </p>
            </Section>

            <Section title="Best discard">
              <p style={{ margin: 0 }}>
                {analysis.bestDiscard
                  ? `Discard ${analysis.bestDiscard.rank}${suit(analysis.bestDiscard.suit)} (highest deadwood).`
                  : 'No deadwood — consider declaring!'}
              </p>
            </Section>

            <button
              onClick={() => setOpen(false)}
              style={{
                marginTop: 16,
                width: '100%',
                padding: '10px',
                borderRadius: 8,
                background: '#f59e0b',
                color: '#1a1a2e',
                border: 'none',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default HintPanel;
